import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/feature/PageHero";
import Reveal from "@/components/base/Reveal";
import InquiryForm from "@/components/feature/InquiryForm";
import { photos, images } from "@/mocks/site";

const services = [
  {
    no: "01",
    title: "Private Events",
    note: "Intimate dinners and celebrations cooked in person, start to finish.",
  },
  {
    no: "02",
    title: "Culinary Demonstrations",
    note: "Hands-on sessions that teach technique with a story behind it.",
  },
  {
    no: "03",
    title: "Speaking",
    note: "Talks on food, travel, community and the locavore idea.",
  },
  {
    no: "04",
    title: "Hosting",
    note: "An effortless host for launches, premieres and gatherings.",
  },
  {
    no: "05",
    title: "Brand Collaborations",
    note: "Thoughtful partnerships built around real, honest food.",
  },
  {
    no: "06",
    title: "Special Appearances",
    note: "Guest moments that bring warmth and credibility to a room.",
  },
];

export default function HireEddiePage() {
  return (
    <SiteLayout>
      <PageHero
        eyebrow="Bring Eddie · Hire"
        title={
          <>
            HIRE
            <br />
            EDDIE
          </>
        }
        subtitle="Culinary experiences, private events and professional engagements — brought to life with care, craft and a lot of character."
        image={photos.marina}
        imageClassName="object-center"
      />

      <section className="bg-background-50">
        <div className="w-full px-5 md:px-10 lg:px-16 py-20 md:py-28">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
            <div className="lg:col-span-6">
              <Reveal>
                <p className="eyebrow">What Eddie Brings</p>
              </Reveal>
              <Reveal delay={120}>
                <h2 className="mt-5 font-heading text-3xl leading-[1.05] text-foreground-950 sm:text-4xl md:text-5xl">
                  Craft, warmth and a room that{" "}
                  <span className="italic text-primary-600">comes alive.</span>
                </h2>
              </Reveal>
            </div>
            <div className="lg:col-span-5 lg:col-start-8 lg:self-end">
              <Reveal delay={200}>
                <p className="font-body text-base leading-relaxed text-foreground-700">
                  Whatever the brief, the result is the same — food that feels
                  personal and a host who makes everyone feel at home.
                </p>
              </Reveal>
            </div>
          </div>

          <div className="mt-14 grid grid-cols-1 gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((s, i) => (
              <Reveal key={s.no} delay={i * 70}>
                <div className="border-t border-foreground-950/12 pt-6">
                  <span className="font-heading text-lg italic text-primary-500">
                    {s.no}
                  </span>
                  <h3 className="mt-3 font-heading text-2xl text-foreground-950">
                    {s.title}
                  </h3>
                  <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600">
                    {s.note}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100">
        <div className="w-full px-5 md:px-10 lg:px-16 py-20 md:py-28">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
            <div className="lg:col-span-5">
              <Reveal>
                <div className="aspect-[4/5] w-full overflow-hidden bg-foreground-900 image-zoom">
                  <img
                    src={images.cellar}
                    alt="A cellar of barrels"
                    className="h-full w-full object-cover object-center"
                  />
                </div>
              </Reveal>
            </div>
            <div className="lg:col-span-6 lg:col-start-7">
              <Reveal delay={120}>
                <InquiryForm
                  title="Hire Eddie"
                  description="Share the shape of your event and what you'd love Eddie to do. We'll take it from there."
                  submitLabel="Send Inquiry"
                />
              </Reveal>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}